import { useState } from "react";
import PopUp from "../PopUp";
import NumericPinPad from "../ui/NumericPinPad";
import functions from "../../functions/functions";

const FRACTIONS = [
    { label: "1/2", divider: 2 },
    { label: "1/3", divider: 3 },
    { label: "1/4", divider: 4 },
    { label: "1/5", divider: 5 },
    { label: "1/6", divider: 6 },
    { label: "1/7", divider: 7 },
    { label: "1/8", divider: 8 },
    { label: "1/9", divider: 9 },
    { label: "1/10", divider: 10 },
];

function roundNumber(number) {
    return Math.round(number * 10) / 10;
}

function SplitPartialPopup({ product, onConfirm, onClose }) {
    const [customMode, setCustomMode] = useState(false);

    const price = parseFloat(product.price);

    const handleFraction = (divider) => {
        onConfirm(roundNumber(price / divider));
    };

    const handleCustom = (value) => {
        const amount = roundNumber(parseFloat((value || "0").toString().replace(",", ".")));
        if (isNaN(amount) || amount <= 0 || amount >= price) {
            alert("Importo non valido");
            return;
        }
        onConfirm(amount);
    };

    return (
        <PopUp
            size="sm"
            customClass="split-partial-popup"
            options={{
                onClose: onClose,
                title: "Dividi " + product.name,
                subtitle: functions.formatter.format(price),
                content: (
                    <div className="split-partial">
                        {!customMode && (
                            <>
                                <div className="fraction-buttons">
                                    {FRACTIONS.map((f) => (
                                        <button
                                            key={f.label}
                                            className="button"
                                            onClick={() => handleFraction(f.divider)}
                                        >
                                            <span>{f.label}</span>
                                            <span className="fraction-amount">
                                                {functions.formatter.format(roundNumber(price / f.divider))}
                                            </span>
                                        </button>
                                    ))}
                                </div>
                                <button className="button button-2" onClick={() => setCustomMode(true)}>
                                    Scegli Importo personalizzato
                                </button>
                            </>
                        )}
                        {customMode && <NumericPinPad onSubmit={handleCustom} showEuroSign={true} />}
                    </div>
                ),
            }}
        />
    );
}

export default SplitPartialPopup;
